﻿export const defaultMeta = {
    title: "Masticando",
    description: "Masticando nasce con un obiettivo preciso: offrire ai professionisti del settore cinofilo prodotti funzionali per il processo di apprendimento del cane e per le attività di riduzione degli indici di stress.",
    author: "masticando",
    robots: "index,follow",
    keywords: "masticativi per cani, masticativi naturali per cani, masticativi per educatori cinofili, riduzione stress cani, benessere del cane, prodotti naturali per cani, masticativi di lunga durata per cani, ossa naturali per cani, carne essiccata per cani, educamasticando, supporto educativo per cani, masticativi per cani sportivi, masticativi per cuccioli, masticativi per cani adulti, masticativi per cani anziani, aorta, trachea, polmone, cuore, fegato, nervo, cotenna, orecchie, carne essiccata, padiglioni, carne di cavallo",
};


export function updateMetaInfo(metaPassed = null) {

    const metaInfo = metaPassed || defaultMeta;

    // Update the title
    document.title = metaInfo.title || defaultMeta.title;

    // Update meta tags
    const metaTags = [
        { name: "description", content: metaInfo.description || defaultMeta.description },
        { name: "author", content: metaInfo.author || defaultMeta.author },
        { name: "robots", content: metaInfo.robots || defaultMeta.robots },
        { name: "keywords", content: metaInfo.keywords || defaultMeta.keywords },
    ];

    const metaProperties = metaPassed.properties || [];

    metaTags.forEach(({ name, content }) => {
        let tag = document.querySelector(`meta[name="${name}"]`);
        if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute("name", name);
            document.head.appendChild(tag);
        }
        tag.setAttribute("content", content);
    });

    metaProperties.forEach(({ property, content }) => {
        let tag = document.querySelector(`meta[property="${property}"]`);
        if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute("property", property);
            document.head.appendChild(tag);
        }
        tag.setAttribute("content", content);
    });
}